module.exports = __webpack_public_path__ + "img/setting.cfdd822f.png";